import { render, staticRenderFns } from "./fun_pres_changes.vue?vue&type=template&id=3cd96840"
import script from "./fun_pres_changes.vue?vue&type=script&lang=js"
export * from "./fun_pres_changes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports